import  React from 'react';
import jmsLogo from '@Assets/images/Logo/jms-logo.png';
import {Button} from "primereact/button";
import appAndroidImage from "@Assets/images/logo_googleplay_jms.png";
import appIosImage from "@Assets/images/logo_applestore_jms.png";
import {usePage} from "@inertiajs/react";
import {LoginProps} from "@Pages/Auth/Login/LoginType";


function LogoLogin() {

  const {settings} = usePage().props as LoginProps;
  const { androidAppLink, iosAppLink, sso} = settings;

  const appLinks = [
    { alt: 'App Android', link: androidAppLink, image: appAndroidImage },
    { alt: 'App IOS', link: iosAppLink, image: appIosImage },
  ];
  return (
    <div className="flex justify-content-between" style={{margin: '-1rem 0 3rem'}}>
      {appLinks.map((link) => (
        <Button
          text
          key={link.alt}
          onClick={() => window.open(link.link, '_blank', 'noopener noreferrer')}
          className="text-700 m-0 justify-content-center flex"
          style={{background: 'black', borderRadius: '7px', width: '47%'}}
        >
          <img src={link.image} alt={link.alt} height="40"/>
        </Button>
      ))}
    </div>
  );
}

export default LogoLogin;
